import React from "react";
import AuditTrail from "../../../components/AuditTrail";
import { ApiURL } from "../../../services/apiConstants";

export default function AuditPage() {
  return <AuditTrail endpoint={ApiURL.staff_api_cargo_audit_logs_st} />;
}
